import { AlertTriangle } from "lucide-react";
import { BackLink } from "@/store/components/Header";

/** Error / empty-results view. Shows a "Back to store" link when a filter is active. */
export default function ErrorState({ message, showBack }: { message: string; showBack: boolean }) {
  return (
    <div>
      <div className="agd:mb-6 agd:flex agd:items-center agd:gap-2.5 agd:rounded-lg agd:border agd:border-[#feb2b2] agd:bg-[#fff5f5] agd:px-5 agd:py-4 agd:text-[0.9rem] agd:text-[#c53030]">
        <AlertTriangle size={18} className="agd:flex-shrink-0" />
        <span>{message}</span>
      </div>
      {showBack ? <BackLink /> : null}
    </div>
  );
}
